import { request } from "../utils/request.js"

export const sysRole_addNew = (pojo, args) => request({
    url: 'sysRole/addNew',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})
export const sysRole_update = (pojo, args) => request({
    url: 'sysRole/update',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})
export const sysRole_findById = (id, args) => request({
    url: 'sysRole/findById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})
export const sysRole_deleteById = (id, args) => request({
    url: 'sysRole/deleteById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const sysRole_findByPage = (pojo, args) => request({
    url: 'sysRole/findByPage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const sysRole_checkDistribute = (roleId, userIdList, args) => request({
    url: 'sysRole/checkDistribute',
    method: 'POST',
    params: {
        roleId,
        userIdList
    },
    showFailMessage: true,
    ...args
})

export const sysRole_findRoleUserPage = (pojo, args) => request({
    url: 'sysRole/findRoleUserPage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const sysRole_findPageForSelect = (pojo, args) => request({
    url: 'sysRole/findPageForSelect',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const sysRole_addUserToRole = (pojo, args) => request({
    url: 'sysRole/addUserToRole',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const sysRole_cancelUserFromRole = (pojo, args) => request({
    url: 'sysRole/cancelUserFromRole',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const sysRole_findUnfrozenList = (args) => request({
    url: 'sysRole/findUnfrozenList',
    method: 'GET',
    showFailMessage: true,
    ...args
})

export const sysRole_getRoleByUserId = (userId, args) => request({
    url: 'sysRole/getRoleByUserId',
    method: 'GET',
    params: {
        userId
    },
    showFailMessage: true,
    ...args
})

export const sysRole_changeFrozenStatus = (id, args) => request({
    url: 'sysRole/changeFrozenStatus',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})


// WEBPACK FOOTER //
// ./src/api/sysRole.js